import Entity from '../entity'
import Product from './Product';

export default class ProductCategory extends Entity<number> {
    name: string = null;
    description: string = null;
    keywords: string;
    coverImageUrl: string = null;
    parentId: number = null;
    isRecommended: boolean;
    recommendedBannerImageUrl: string = null;
    adImageUrl: string = null;
    adTargetUrl: string = null;
    bannerImageUrl: string = null;
    hotSellingBannerImageUrl: string = null;
    tenantId: number = null;
    isAdvertised: boolean;
    adPriority: number = null;
    isPublished: boolean;
    priority: number = null;
    remark: string = null;
    products: Array<Product>;
    isFooterLink: boolean;
    productCategoryNo: string;
    children: Array<ProductCategory>;
}